import { Handle, Position } from '@xyflow/react';

// Purely decorative node that indicates where the flow starts. It has a
// single output handle (with id "out") that we wire to the InitialNodeId.
// No data, not draggable into/out of, not deletable — purely a visual marker.
export function StartNode() {
  return (
    <div className="fb-start-node" title="Flow starts here">
      <div className="fb-start-node-icon">▶</div>
      <div className="fb-start-node-label">Start</div>
      <Handle
        type="source"
        position={Position.Bottom}
        id="out"
        className="fb-handle fb-handle--start"
        isConnectable={false}
      />
    </div>
  );
}
